import {Component, Vue} from "vue-property-decorator";
import dayjs from "dayjs";

@Component
export default class FormattersMixin extends Vue {
    dayjsFormatter(value: any, key: string, item: {[key: string]: any}) {
        return value ? dayjs(value).format("DD.MM.YYYY, HH:mm:ss") : null
    }
}